import { TimeOfDay } from "@/types/date"

export const DEFAULT_HOTEL_CHECKIN_TIME: TimeOfDay = { hour: 15, minute: 0 }
export const DEFAULT_HOTEL_CHECKOUT_TIME: TimeOfDay = { hour: 12, minute: 0 }
// export const DEFAULT_RESTAURANT_LUNCH_START_TIME: TimeOfDay = { hour: 12, minute: 0 }
// export const DEFAULT_RESTAURANT_LUNCH_END_TIME: TimeOfDay = { hour: 13, minute: 30 }
export const DEFAULT_RESTAURANT_DINNER_START_TIME: TimeOfDay = {
  hour: 18,
  minute: 0,
}
export const DEFAULT_RESTAURANT_DINNER_END_TIME: TimeOfDay = {
  hour: 20,
  minute: 30,
}
export const DEFAULT_ATTRACTION_START_TIME: TimeOfDay = { hour: 10, minute: 0 }
export const DEFAULT_ATTRACTION_END_TIME: TimeOfDay = { hour: 15, minute: 0 }
export const DEFAULT_EVENT_START_TIME = DEFAULT_ATTRACTION_START_TIME // TODO maybe change
export const DEFAULT_EVENT_END_TIME = DEFAULT_ATTRACTION_END_TIME // TODO maybe change
export const DEFAULT_ACTIVITY_START_TIME = DEFAULT_ATTRACTION_START_TIME
export const DEFAULT_ACTIVITY_END_TIME = DEFAULT_ATTRACTION_END_TIME
export const DEFAULT_CUSTOM_START_TIME = { hour: 10, minute: 0 }
export const DEFAULT_CUSTOM_END_TIME = { hour: 11, minute: 30 }
// How long an event runs when the user never said: the custom event form with
// nothing dragged behind it, and a calendar click too short to be a real drag.
export const DEFAULT_EVENT_DURATION_HOURS = 1
export const MAX_ITINERARY_EVENT_USER_NOTE_LENGTH = 4000
export const DEFAULT_LOCATION_START_TIME = { hour: 10, minute: 0 }
export const DEFAULT_LOCATION_END_TIME = { hour: 11, minute: 30 }
export const DEFAULT_RENTAL_CAR_CHECKIN_TIME: TimeOfDay = {
  hour: 12,
  minute: 0,
}
export const DEFAULT_RENTAL_CAR_CHECKOUT_TIME: TimeOfDay = {
  hour: 12,
  minute: 0,
}

export const DEFAULT_HOTEL_TIME_SPAN = 1.5
export const DEFAULT_RESTAURANT_TIME_SPAN = 1.5
export const DEFAULT_ATTRACTION_TIME_SPAN = 5
export const DEFAULT_ACTIVITY_TIME_SPAN = 5
export const DEFAULT_LOCATION_TIME_SPAN = 1.5
export const DEFAULT_CAR_RENTAL_TIME_SPAN = 1.0
export const DEFAULT_OTHER_TIME_SPAN = 1.5
